const Joi = require("joi");

const paymentGatewaySchema = (data) => {
  const schema = Joi.object({
    IsPaypalActive: Joi.number().valid(0, 1).required(), // Ensures IsPaypalActive is always 0 or 1 and present
    IsPaypalActiveInMobile: Joi.number().valid(0, 1).required(), // Ensures IsPaypalActiveInMobile is always 0 or 1 and present
    Notes: Joi.alternatives().conditional(Joi.ref("IsPaypalActive"), {
      is: 0,
      then: Joi.string().trim().invalid("").required().messages({
        "string.empty": "Please enter Notes.",
        "any.required": "Please enter Notes.",
      }),
      otherwise: Joi.optional().strip(), // Remove this field when InmateUploadType is not 'ftp'
    }),

    MaintenanceNotesforMobile: Joi.alternatives().conditional(
      Joi.ref("IsPaypalActiveInMobile"),
      {
        is: 0,
        then: Joi.string().trim().invalid("").required().messages({
          "string.empty": "Please enter Notes.",
          "any.required": "Please enter Notes.",
        }),
        otherwise: Joi.optional().strip(), // Remove this field when InmateUploadType is not 'ftp'
      }
    ),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false, // This ensures that all validation errors are reported, not just the first one.
  });
};

module.exports = paymentGatewaySchema;
